// extracted by mini-css-extract-plugin
export default {"wrapper":"commonStyles_wrapper__gNckQ","text":"commonStyles_text__I4dBs"};